export const idvFraudScreenStatus = {
	FRAUD_SCREEN_STATUS_VERIFIED: 'FRAUD_SCREEN_STATUS_VERIFIED',
	FRAUD_SCREEN_STATUS_NOT_VERIFIED: 'FRAUD_SCREEN_STATUS_NOT_VERIFIED',
	FRAUD_SCREEN_STATUS_DENIED: 'FRAUD_SCREEN_STATUS_DENIED',
	FRAUD_SCREEN_STATUS_WAITING_ROOM: 'FRAUD_SCREEN_STATUS_WAITING_ROOM',
	ERROR: 'error',
} as const;

export type IdvFraudScreenStatus = (typeof idvFraudScreenStatus)[keyof typeof idvFraudScreenStatus];

export const idvVerificationAction = {
	VERIFICATION_ACTION_REVIEW_PII: 'VERIFICATION_ACTION_REVIEW_PII',
	VERIFICATION_ACTION_REVIEW_DOCUMENTS: 'VERIFICATION_ACTION_REVIEW_DOCUMENTS',
	VERIFICATION_ACTION_NONE: 'VERIFICATION_ACTION_NONE',
} as const;

export type IdvVerificationAction =
	(typeof idvVerificationAction)[keyof typeof idvVerificationAction];

export const idvScreenNames = {
	CHECK_LOADER: 'CHECK_LOADER',
	CELEBRATION: 'CELEBRATION',
	HARD_FAIL: 'HARD_FAIL',
	ALLOY_OUTAGE: 'ALLOY_OUTAGE',
	DOC_UPLOAD: 'DOC_UPLOAD',
	MANUAL_REVIEW: 'MANUAL_REVIEW',
	IDV_FLOW: 'IDV_FLOW',
	GENERIC_ERROR: 'GENERIC_ERROR',
} as const;

export type IdvScreenName = (typeof idvScreenNames)[keyof typeof idvScreenNames];

export const idvTimeouts = {
	POLLING_INTERVAL: 3_000, // 3 secs
	POLLING_TIMEOUT_LIMIT: 30_000, // 30 secs
	RETURN_DELAY: 5_000, // 5 secs
} as const;

export const idvPxQuestionsAnswerTypes = {
	COMPLETE: 'COMPLETE',
	INCOMPLETE: 'INCOMPLETE',
} as const;

export type IdvPxQuestionsAnswerType =
	(typeof idvPxQuestionsAnswerTypes)[keyof typeof idvPxQuestionsAnswerTypes];

export const IDV_PX_QUESTION_NAME = 'onboarding-identity-verification-status';
export const RETURN_TO_KEY = 'returnTo';
export const RETURN_TO_VALUE = 'idvFlow';
